import { render, staticRenderFns } from "./terminalPickup.vue?vue&type=template&id=2335e3c5&"
import script from "./terminalPickup.vue?vue&type=script&lang=js&"
export * from "./terminalPickup.vue?vue&type=script&lang=js&"
import style0 from "./terminalPickup.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports